<span class="symbol symbol-lg-{{ size + 10 }} symbol-{{ size }} symbol-light-primary">
    <div class="round symbol-label">
        <span class="font-size-{{ fontSize }} font-weight-bold mt-1">
            {{ name ? name[0] : 'N/A' }}
        </span>
    </div>
</span>
